import {useOktaAuth} from "@okta/okta-react";
import {useAuthState} from "../../../providers/AuthProvider";
import {navigateToCmsOrder} from "../../../services/CmsService";
import {StyledLink} from "../../common/StyledLink";
import {usePreferenceContext} from "../../../providers/PreferenceProvider";
import styled from "@emotion/styled";

export type TMissingTimeWindowJobDetails = {
  jobNumber: string;
  jobId: number;
  orderId: number;
};

export interface TimeWindowValidationContentProps {
  jobs: TMissingTimeWindowJobDetails[];
  // "missing": a pickup has no usable window; "inverted": a stop's Early time is after its Late time
  reason?: "missing" | "inverted";
}

const TimeWindowValidationContent = ({jobs, reason = "missing"}: TimeWindowValidationContentProps) => {
  const {tenant} = useAuthState();
  const {oktaAuth} = useOktaAuth();
  const {tenantPreferences} = usePreferenceContext();

  const handleGoToCmsOrder = async (orderID: number | undefined) => {
    await navigateToCmsOrder(tenant!, oktaAuth.getAccessToken() ?? "", orderID, tenantPreferences);
  };

  return (
    <Container>
      <List>
        {jobs.length > 0 && (
          <li>
            Job{" "}
            <>
              {jobs.map((item, index) => (
                <>
                  <StyledLink
                    key={item.jobId}
                    data-testid={`order-link-of-${item.jobId}`}
                    onClick={() => void handleGoToCmsOrder(item.orderId)}
                  >
                    {item.jobNumber}
                  </StyledLink>
                  {index < jobs.length - 1 ? ", " : ""}
                </>
              ))}
            </>{" "}
            {jobs.length > 1 ? "contain" : "contains"}{" "}
            {reason === "inverted"
              ? "stops whose time window ends before it starts."
              : "stops that are missing Time Window data points."}
          </li>
        )}
      </List>
      Please make the necessary adjustments and try again.
    </Container>
  );
};

export default TimeWindowValidationContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 16px;
  & > li:not(:last-of-type) {
    margin-bottom: 12px;
  }
`;
